import React, { useState } from "react";

import styled from "styled-components";

import { useFlocknoteAppState } from "Flocknote/state";
import { useIsBillingAdmin, useIsSuperAdmin } from "Flocknote/stateHooks";

import Portal from "Utilities/PortalMaker";
import { useDashboardPortalElement } from "Utilities/PortalMaker/useDashboardPortalElement";

import SmartGroupPromoContent from "./SmartGroupPromoContent";

/**
 * Smart group promo on people page for when a smart group
 * is using a filter they no longer have access to
 * like when they downgrade from Complete to Standard
 * but are using custom profile fields in their filter
 */

export default function SmartGroupPromoSplash() {
  const [state] = useFlocknoteAppState();
  const [childCount, setChildCount] = useState(0);
  const portalToElement = useDashboardPortalElement({
    selector: ".smart_group_promo",
    childCount,
    setChildCount,
    dashboardTick: state.dashboardTick,
  });

  const isBillingAdmin = useIsBillingAdmin();
  const isSuperAdmin = useIsSuperAdmin();

  if (!portalToElement) return null;
  return (
    <Portal to={portalToElement}>
      <Splash>
        <SmartGroupPromoContent
          showUpgradeButton={isSuperAdmin && isBillingAdmin}
        />
      </Splash>
    </Portal>
  );
}
const Splash = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  place-items: center;
  overflow: auto;
`;